import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getCartQuantity } from '../../layout/store/thunk'
import CartAndOrderService from '../core/service'

export const getCartItems = createAsyncThunk(
  'cartAndOrder/getCartItems',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getCartItems(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const delCartItem = createAsyncThunk(
  'cartAndOrder/delCartItem',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await CartAndOrderService.delCartItem(params)
      if (res.success) {
        dispatch(getCartQuantity())
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postOrder = createAsyncThunk(
  'cartAndOrder/postOrder',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await CartAndOrderService.postOrder(params)
      if (res.success) {
        dispatch(getCartQuantity())
        return res.data
      }
      return rejectWithValue({ loading: false, data: res.data })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, error: err.response })
    }
  },
)

export const postOrderZero = createAsyncThunk(
  'cartAndOrder/postOrderZeroAmount',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await CartAndOrderService.postOrderZero(params)
      if (res.success) {
        dispatch(getCartQuantity())
        return res.data
      }
      return rejectWithValue({ loading: false, data: res.data })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDiscount = createAsyncThunk(
  'cartAndOrder/getDiscount',
  async (_, { rejectWithValue, getState }) => {
    const params = getState()?.['cartAndOrder']?.paramsDiscount
    try {
      const res = await CartAndOrderService.getDiscount({
        DiscountObjectTypes: params.toString(),
      })
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getVoucher = createAsyncThunk(
  'cartAndOrder/getVoucher',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getVoucher(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)

export const getUserPricingPackages = createAsyncThunk(
  'cartAndOrder/getUserPricingPackages',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getUserPricingPackages(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)

export const getBankTransferInfo = createAsyncThunk(
  'cartAndOrder/getBankTransferInfo',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getBankTransferInfo(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)

export const getSimilarCompanies = createAsyncThunk(
  'cartAndOrder/getSimilarCompanies',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getSimilarCompanies(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)

export const getMostPopularCompanies = createAsyncThunk(
  'cartAndOrder/getMostPopularCompanies',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getMostPopularCompanies(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)

export const getUserProfile = createAsyncThunk(
  'cartAndOrder/getUserProfile',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getUserProfile(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)

export const getTerms = createAsyncThunk(
  'cartAndOrder/getTerms',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CartAndOrderService.getTerms(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)
